import React from 'react';
import { Row, Col, DropdownButton, Checkbox, MenuItem, Pagination, } from 'react-bootstrap';
import unitConverter from 'convert-units';
import DriverActionCreators from 'actions/DriverActionCreators';
import DriverStore from 'stores/DriverStore';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { getEquipmentTypesForShipmentTypes } from 'constants/EquipmentTypes';
import { withLocaleContext } from 'providers/locale-settings-context';
import DriverList from './DriverList';
import { DRIVER_SEARCH_DISTANCE_OPTIONS } from './mappings';
function getStateFromStores() {
    const state = DriverStore.getNearbyDrivers();
    return {
        drivers: state.nearbyDrivers,
        totalNearbyDrivers: state.totalPages,
        loading: state.nearbyDrivers.length === 0,
    };
}
// TODO: rewrite this to accept different strategies: proximity, rating, history, price sensitivity etc
class DriverSuggestions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            drivers: [],
            loading: true,
            truck_type_label: titleize(props.t('ALL')),
            filters: {
                distance: DRIVER_SEARCH_DISTANCE_OPTIONS.driver_suggestions[REGION_CODE][0],
                page: 1,
                near: this.props.shipment.origin[0].coords,
                exclusive_carriers: true,
                carriers: this.props.shipment.shipper.carriers,
                per_page: 5,
                paginate: true,
                truck_type: titleize(props.t('ALL')),
            },
        };
    }
    componentDidMount() {
        const { localeData } = this.props;
        DriverActionCreators.getNearbyDrivers(Object.assign(Object.assign({}, this.state.filters), { distance: unitConverter(this.state.filters.distance)
                .from(localeData.distance_units)
                .to('m')
                .toFixed(2) }), this.props.shipment.shipper._id, this.props.shipment.shipment_type);
        this.pollInterval = setInterval(() => DriverActionCreators.getNearbyDrivers(Object.assign(Object.assign({}, this.state.filters), { distance: unitConverter(this.state.filters.distance)
                .from(localeData.distance_units)
                .to('m')
                .toFixed(2) }), this.props.shipment.shipper._id), 30000);
        DriverStore.addChangeListener(this._onChange.bind(this));
    }
    componentWillUnmount() {
        clearInterval(this.pollInterval);
        DriverStore.removeChangeListener(this._onChange);
    }
    onPaginationSelect(eventKey) {
        const { localeData } = this.props;
        const filters = this.state.filters;
        filters.page = eventKey;
        this.setState((prevState) => {
            return Object.assign(Object.assign({}, prevState), { filters });
        });
        DriverActionCreators.getNearbyDrivers(Object.assign(Object.assign({}, filters), { distance: unitConverter(filters.distance)
                .from(localeData.distance_units)
                .to('m')
                .toFixed(2) }));
    }
    _onChange() {
        const newState = getStateFromStores();
        this.setState((prevState) => {
            const updatedState = Object.assign({}, prevState, newState, {
                totalPages: Math.ceil(newState.totalNearbyDrivers / prevState.filters.per_page),
            });
            return Object.assign(Object.assign({}, prevState), updatedState);
        });
    }
    handleExclusiveCarriers(checked) {
        const { localeData } = this.props;
        const filters = this.state.filters;
        filters.exclusive_carriers = checked;
        filters.carriers = checked ? this.props.shipment.shipper.carriers : [];
        filters.page = 1;
        this.setState((prevState) => {
            return Object.assign(Object.assign({}, prevState), { filters });
        });
        DriverActionCreators.getNearbyDrivers(Object.assign(Object.assign({}, filters), { distance: unitConverter(filters.distance)
                .from(localeData.distance_units)
                .to('m')
                .toFixed(2) }), this.props.shipment.shipper._id);
    }
    handleTruckType(type) {
        const { localeData } = this.props;
        let filters;
        this.setState((prevState) => {
            filters = prevState.filters;
            filters.truck_type = type;
            filters.page = 1;
            return Object.assign(Object.assign({}, prevState), { truck_type_label: this.getTruckTypeLabel(type), filters });
        }, () => {
            DriverActionCreators.getNearbyDrivers(Object.assign(Object.assign({}, this.state.filters), { distance: unitConverter(this.state.filters.distance)
                    .from(localeData.distance_units)
                    .to('m')
                    .toFixed(2) }));
        });
    }
    getTruckTypeLabel(truckType) {
        const { t } = this.props;
        if (truckType.toLowerCase() === 'all')
            return titleize(t('ALL'));
        const equipmentType = this.getCurrentEquipmentTypes().find((eqType) => eqType.label === truckType);
        return t(equipmentType.label);
    }
    handleDistance(value) {
        const { localeData } = this.props;
        const filters = this.state.filters;
        filters.distance = value;
        filters.page = 1;
        this.setState((prevState) => {
            return Object.assign(Object.assign({}, prevState), { filters });
        });
        DriverActionCreators.getNearbyDrivers(Object.assign(Object.assign({}, filters), { distance: unitConverter(value)
                .from(localeData.distance_units)
                .to('m')
                .toFixed(2) }));
    }
    getCurrentEquipmentTypes() {
        // Prefer the array if present and non-empty, else fallback to single shipment
        const shipments = Array.isArray(this.props.shipments) && this.props.shipments.length
            ? this.props.shipments
            : [this.props.shipment].filter(Boolean);
        const selectedShipmentTypes = [
            ...new Set(shipments.map((s) => s === null || s === void 0 ? void 0 : s.shipment_type).filter(Boolean)),
        ];
        return getEquipmentTypesForShipmentTypes(selectedShipmentTypes) || [];
    }
    render() {
        let component;
        const { t, onAssignDriver, shipment, carrierPreferences } = this.props;
        if (this.state.loading) {
            component = t('GETTING_DRIVER_SUGGESTIONS');
        }
        else {
            component = [
                React.createElement(DriverList, { key: 0, carrierPreferences: carrierPreferences, shipment: shipment, nearbyDrivers: this.state.drivers, onAssignDriver: onAssignDriver }),
                React.createElement(Pagination, { first: true, last: true, ellipsis: true, key: 1, items: this.state.totalPages, maxButtons: 10, activePage: this.state.filters.page, onSelect: (eventKey) => this.onPaginationSelect(eventKey) }),
            ];
        }
        return (React.createElement("div", { "data-testid": "div-9b5a28bb" },
            React.createElement(Row, null,
                React.createElement(Col, { xs: 1 },
                    React.createElement("h4", { "data-testid": "h4-1c9c2d5d" }, titleize(t('FILTER', { count: 2 })))),
                React.createElement(Col, { xs: 3 },
                    React.createElement(Checkbox, { checked: this.state.filters.exclusive_carriers, onChange: (e) => this.handleExclusiveCarriers(e.target.checked) }, t('EXCLUSIVE_CARRIERS'))),
                React.createElement(Col, { xs: 3, style: { marginTop: 10 } },
                    t('TRUCK_TYPE'),
                    React.createElement(DropdownButton, { style: { marginLeft: 5 }, title: this.state.truck_type_label, id: "bg-nested-dropdown", bsSize: "xsmall", bsStyle: "success", onSelect: (e) => this.handleTruckType(e) },
                        React.createElement(MenuItem, { eventKey: "All" }, titleize(t('ALL'))),
                        this.getCurrentEquipmentTypes().map((equipmentType) => {
                            return (React.createElement(MenuItem, { eventKey: equipmentType.label, key: equipmentType.label }, titleize(t(equipmentType.label))));
                        }))),
                React.createElement(Col, { xs: 4, style: { marginTop: 10 } },
                    t('NEARBY_RADIUS'),
                    React.createElement(DropdownButton, { style: { marginLeft: 5 }, bsSize: "xsmall", bsStyle: "success", id: "radius-dropdown", title: this.state.filters.distance }, DRIVER_SEARCH_DISTANCE_OPTIONS.driver_suggestions[REGION_CODE].map((value) => {
                        return (React.createElement(MenuItem, { eventKey: value, onSelect: () => this.handleDistance(value) }, value));
                    })))),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 }, component))));
    }
}
export default withTranslation()(withLocaleContext(DriverSuggestions));
